<template>
  <section class="checkout-content p-0">
    <div class="dashboard-container">
      <div class="container-fluid">
        <div class="row" style="min-height: calc(100vh - 197px);">
          <nav class="col-md-3 col-lg-2 sidebar">
            <div class="sidebar-sticky">
              <ul class="nav">
                <!--<li class="nav-item">-->
                <!--<a class="nav-link active" href="#">-->
                <!--<svg xmlns="http://www.w3.org/2000/svg"-->
                <!--width="24"-->
                <!--height="24"-->
                <!--viewBox="0 0 24 24"-->
                <!--fill="none"-->
                <!--stroke="currentColor"-->
                <!--stroke-width="2"-->
                <!--stroke-linecap="round"-->
                <!--stroke-linejoin="round"-->
                <!--class="feather feather-home"-->
                <!--&gt;-->
                <!--<path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>-->
                <!--<polyline points="9 22 9 12 15 12 15 22"></polyline>-->
                <!--</svg>-->
                <!--Dashboard-->
                <!--<span class="sr-only">-->
                <!--(current)-->
                <!--</span>-->
                <!--</a>-->
                <!--</li>-->

                <li class="nav-item">
                  <router-link
                    to="/vendor/vendorProductListing"
                    class="nav-link"
																				data-test="vendorDashboardViewPdtLink"
																				id="vendorDashboardViewPdtLink"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg"
                         width="24"
                         height="24"
                         viewBox="0 0 24 24"
                         fill="none"
                         stroke="currentColor"
                         stroke-width="2"
                         stroke-linecap="round"
                         stroke-linejoin="round"
                         class="feather feather-shopping-cart"
																									data-test="vendorDashboardViewPdtSvg"
                    >
                      <circle cx="9" cy="21" r="1"></circle>
                      <circle cx="20" cy="21" r="1"></circle>
                      <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6">
                      </path>
                    </svg>
                    Products
                  </router-link>
                </li>
                <li class="nav-item">
                  <router-link to="/vendor/vendorOrderListing"
                               class="nav-link"
																															data-test="vendorDashboardViewOrderLink"
																															id="vendorDashboardViewOrderLink"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg"
                         width="24"
                         height="24"
                         viewBox="0 0 24 24"
                         fill="none"
                         stroke="currentColor"
                         stroke-width="2"
                         stroke-linecap="round"
                         stroke-linejoin="round"
                         class="feather feather-file"
																									data-test="vendorDashboardViewOrderSvg"
                    >
                      <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z">
                      </path>
                      <polyline points="13 2 13 9 20 9"></polyline>
                    </svg>
                    Orders
                  </router-link>
                </li>
                <!--<li class="nav-item">-->
                <!--<a class="nav-link" href="#">-->
                <!--<svg xmlns="http://www.w3.org/2000/svg"-->
                <!--width="24"-->
                <!--height="24"-->
                <!--viewBox="0 0 24 24"-->
                <!--fill="none"-->
                <!--stroke="currentColor"-->
                <!--stroke-width="2"-->
                <!--stroke-linecap="round"-->
                <!--stroke-linejoin="round"-->
                <!--class="feather feather-users"-->
                <!--&gt;-->
                <!--<path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>-->
                <!--<circle cx="9" cy="7" r="4"></circle>-->
                <!--<path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>-->
                <!--<path d="M16 3.13a4 4 0 0 1 0 7.75"></path>-->
                <!--</svg>-->
                <!--Customers-->
                <!--</a>-->
                <!--</li>-->
                <li class="nav-item">
                  <router-link class="nav-link"
                               to="/pages/vendordashboard"
																															data-test="vendorDashboardViewBckLink"
																															id="vendorDashboardViewBckLink"
                  >
                    <svg xmlns:xlink="http://www.w3.org/1999/xlink"
                         xmlns="http://www.w3.org/2000/svg"
                         version="1.1"
                         id="Capa_1"
                         x="0px"
                         y="0px"
                         width="24px"
                         height="24px"
                         viewBox="0 0 459 459"
                         fill="#fff"
                         style="enable-background:new 0 0 459 459;"
                         xml:space="preserve"
																									data-test="vendorDashboardViewBckSvg"
                    >
                      <g>
                        <g id="reply">
                          <path d="M178.5,140.25v-102L0,216.75l178.5,178.5V290.7c127.5,0,216.75,40.8,280.5,130.05C433.5,293.25,357,165.75,178.5,140.25z"/>
                        </g>
                      </g>
                    </svg>
                    Back
                  </router-link>
                </li>
              </ul>

            </div>
          </nav>
          <vendor-dashboard-view-template>
          </vendor-dashboard-view-template>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

import VendorDashboardViewTemplate from '@/components/pages/vendor/vendorStore/VendorDashboardViewTemplate'

export default {
	components: {
		VendorDashboardViewTemplate
	}
}
</script>

<style>

</style>
